/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadImageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UploadImageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UploadImageSecurity = {
  option1?: UploadImageSecurityOption1 | undefined;
  option2?: UploadImageSecurityOption2 | undefined;
};

export type UploadImageRequest = {
  contentLength: number;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  requestBody: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export type UploadImageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UploadImageSecurityOption1$outboundSchema: z.ZodMiniType<
  UploadImageSecurityOption1$Outbound,
  UploadImageSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadImageSecurityOption1ToJSON(
  uploadImageSecurityOption1: UploadImageSecurityOption1,
): string {
  return JSON.stringify(
    UploadImageSecurityOption1$outboundSchema.parse(uploadImageSecurityOption1),
  );
}

/** @internal */
export type UploadImageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UploadImageSecurityOption2$outboundSchema: z.ZodMiniType<
  UploadImageSecurityOption2$Outbound,
  UploadImageSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function uploadImageSecurityOption2ToJSON(
  uploadImageSecurityOption2: UploadImageSecurityOption2,
): string {
  return JSON.stringify(
    UploadImageSecurityOption2$outboundSchema.parse(uploadImageSecurityOption2),
  );
}

/** @internal */
export type UploadImageSecurity$Outbound = {
  Option1?: UploadImageSecurityOption1$Outbound | undefined;
  Option2?: UploadImageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UploadImageSecurity$outboundSchema: z.ZodMiniType<
  UploadImageSecurity$Outbound,
  UploadImageSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UploadImageSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UploadImageSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function uploadImageSecurityToJSON(
  uploadImageSecurity: UploadImageSecurity,
): string {
  return JSON.stringify(
    UploadImageSecurity$outboundSchema.parse(uploadImageSecurity),
  );
}

/** @internal */
export type UploadImageRequest$Outbound = {
  "Content-Length": number;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  RequestBody: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export const UploadImageRequest$outboundSchema: z.ZodMiniType<
  UploadImageRequest$Outbound,
  UploadImageRequest
> = z.pipe(
  z.object({
    contentLength: z.int(),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    requestBody: z.union([
      z.custom<ReadableStream<Uint8Array>>(x => x instanceof ReadableStream),
      z.custom<Blob>(x => x instanceof Blob),
      z.custom<ArrayBuffer>(x => x instanceof ArrayBuffer),
      z.custom<Uint8Array>(x => x instanceof Uint8Array),
    ]),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentLength: "Content-Length",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      requestBody: "RequestBody",
    });
  }),
);

export function uploadImageRequestToJSON(
  uploadImageRequest: UploadImageRequest,
): string {
  return JSON.stringify(
    UploadImageRequest$outboundSchema.parse(uploadImageRequest),
  );
}
